if (!customElements.get('brain-optimized-cards')) {
  customElements.define(
    'brain-optimized-cards',
    class BrainOptimizedCards extends HTMLElement {
      connectedCallback() {
        this._variantCardsMap = null;
        this._defaultCardsHtml = null;
        this._renderedCardsKey = 'default';
        this._didSyncInitialVariant = false;
        this._onVariantChange = this._onVariantChange.bind(this);

        const variantMapEl = this.querySelector('[data-variant-cards-map]');
        const list = this.querySelector('.brain-optimized__cards');
        if (!variantMapEl || !list) return;

        try {
          this._variantCardsMap = JSON.parse(variantMapEl.textContent);
        } catch (error) {
          console.warn('brain-optimized-cards: invalid variant cards map:', error);
          return;
        }

        this._defaultCardsHtml = list.innerHTML;
        document.addEventListener('mp4:variant-change', this._onVariantChange);
        requestAnimationFrame(() => this._syncInitialVariant());
      }

      disconnectedCallback() {
        document.removeEventListener('mp4:variant-change', this._onVariantChange);
      }

      _onVariantChange(event) {
        if (!this._variantCardsMap) return;

        const detail = event.detail || {};
        if (String(detail.productId) !== String(this.dataset.productId)) return;

        this._showCardsForVariant(detail.variantId, detail.variantContentAllowed === true);
      }

      _showCardsForVariant(variantId, variantContentAllowed) {
        const variantKey = String(variantId || '');
        const hasVariantCards =
          variantContentAllowed &&
          Object.prototype.hasOwnProperty.call(this._variantCardsMap, variantKey);
        const nextKey = hasVariantCards ? variantKey : 'default';
        if (this._renderedCardsKey === nextKey) return;

        const list = this.querySelector('.brain-optimized__cards');
        if (!list) return;

        list.innerHTML = hasVariantCards ? this._variantCardsMap[variantKey] : this._defaultCardsHtml;
        this._renderedCardsKey = nextKey;
      }

      /* Main Product v4 can finish its initial selection before this
         component is registered — read its current state so first render
         still receives variant-specific cards. */
      _syncInitialVariant() {
        if (!this._variantCardsMap || this._didSyncInitialVariant) return;

        const mainProduct = Array.from(document.querySelectorAll('main-product-v4')).find(
          (element) => String(element.dataset.productId) === String(this.dataset.productId)
        );
        if (!mainProduct || !mainProduct.dataset.variant) return;

        this._didSyncInitialVariant = true;
        this._showCardsForVariant(
          mainProduct.dataset.variant,
          mainProduct.dataset.variantContentAllowed === 'true'
        );
      }
    }
  );
}
